import {FC} from 'react';
import Image from 'next/image';

import {LayoutPrivacyWidgetProps} from './types';

import styles from '../../styles.module.scss';

const LayoutPrivacyWidget: FC<LayoutPrivacyWidgetProps> = ({show}) => {
  if (!show) return null;

  return (
    <div className={styles.layout__privacyWidget}>
      <Image
        src="/static/svg/icon_lock.svg"
        alt="Lock icon"
        width={17}
        height={20}
      />
      <p>
        <b>Your information is secure.</b>
        We use it to curate our advisor recommendations.
      </p>
    </div>
  );
};

export default LayoutPrivacyWidget;
